import React, { useEffect } from 'react'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListSidebar';
// import SurveyListSidebar from '../../../../../component/'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import { Link } from 'react-router-dom'
import { useVerifySurveyId } from "../../../../../hooks";
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector } from "react-redux";
//import { apiRequest } from "../../../../../services/apiService";
import { updateEloquaSettings, getEloquaSettings } from '../../../../../store/actions/surveyAction';
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
export default function Integrations() {
    const dispatch = useDispatch()

    const { survey_name } = useSelector((state) => state.permissionsData)
    const { eloquaSettings } = useSelector((state) => state.surveyData); // update path as needed
    console.log("eloquaSettings", eloquaSettings);

    const [eloquaActive, setEloquaActive] = React.useState(0);
    const survey_id = useVerifySurveyId()
    const { t, i18n } = useTranslation();
    // const getSurveySelectedIntegration = async () => {

    //     let payload = {
    //         su_survey_id: survey_id
    //     }
    //     const { response, error } = await apiRequest({
    //         method: 'POST',
    //         url: `/survey/getSurveySelectedIntegration`,
    //         data: payload
    //     })
    //     if (response) {
    //         console.log(response)
    //         if (response.data.statusCode == 200) {
    //             setPluginChecked(response.data.data[0].lead_management_plugin);
    //             localStorage.setItem('token_id', response.data.token);
    //         } else {
    //             localStorage.setItem('token_id', response.data.token);
    //             toast.error("Something went wrong, please try again.");
    //         }
    //     }
    //     else if (error) {
    //         toast.error(error);
    //     }
    // }

    const handleChange = (event) => {
        if (eloquaActive != event.target.value) {

            setEloquaActive(event.target.value);
        } else {
            setEloquaActive(0);
        }

    };

    const save = () => {

        const payload = {
            "su_survey_id": survey_id,
            "eloqua_active": parseInt(eloquaActive, 10)
        }
        postData(payload);

    };
    const postData = async function (payload) {
        dispatch(updateEloquaSettings(payload));
        toast.success("Saved successfully");
    }
    const getEloquaActive = () => {
        const payload = {
            "su_survey_id": survey_id
        }
        dispatch(getEloquaSettings(payload))
    }

    useEffect(() => {
        if (survey_id) {
            getEloquaActive();
        }
    }, [survey_id])

    useEffect(() => {
        if (eloquaSettings?.result?.eloqua_active !== undefined) {
            setEloquaActive(eloquaSettings.result.eloqua_active);
        }
    }, [eloquaSettings]);




    return (

        <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column bg-white">
            <div className="share-page-padding dashboard-page-wrap">
                <div className="page-heading">
                    {/* breadcrumbs here */}
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/admin/survey/list">{t('survey.title')}</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                <strong>{t('settings.integration.tittle')}</strong>
                            </li>
                        </ol>
                    </nav>
                    {/* breadcrumbs ends here */}
                    <h1>{t('settings.integration.tittle')}</h1>
                </div>
                <div className="integrations-wrapper">
                    <div className="row gx-3">
                        <div className="col-lg-3 col-md-6 mb-3">
                            <div className="position-relative">

                                <input className="form-check-input" type="radio" name="integration" id="integration2"
                                    value={1}
                                    checked={eloquaActive == 1 ? true : false}
                                    onClick={window.modulePermissions.M17.edit == 1 ? (e) => handleChange(e) : undefined}
                                    disabled={window.modulePermissions.M17.edit != 1}
                                />

                                <label htmlFor='integration2' className="integration-inner">
                                    <div className='heading'>{t('settings.integration.eloqua')}</div>
                                    <div className="descrition">{t('settings.integration.text')}</div>
                                    <Link to={`/admin/survey/integration/eloqua-settings?survey_id=${survey_id}`}>{t('settings.integration.settings')}
                                    </Link>


                                </label>
                            </div>

                        </div>
                        {window.modulePermissions.M17.edit == 1 && (<div className="button-wrap pt-2">
                            <button className="btn btn-primary" type="button" onClick={() => save()}> {t('settings.integration.save')}</button>

                        </div>)}
                    </div>
                </div>
            </div>
        </div>
    )
}
